<template>
  <el-dialog
    title="编辑设备"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-escape="false"
    width="60%"
    @closed="handleClose"
  >
    <el-form
      ref="editForm"
      :model="formData"
      :rules="formRules"
      label-width="120px"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备IP" prop="host_ip">
            <el-input v-model="formData.host_ip" placeholder="请输入设备IP" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备名称" prop="hostname">
            <el-input v-model="formData.hostname" placeholder="请输入设备名称" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="IPMI地址" prop="ipmi_addr">
            <el-input v-model="formData.ipmi_addr" placeholder="请输入IPMI地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="IPMI用户" prop="ipmi_user">
            <el-input v-model="formData.ipmi_user" placeholder="请输入IPMI用户" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备类型" prop="dev_type">
            <el-select v-model="formData.dev_type" placeholder="请选择设备类型" style="width: 100%" :disabled="isNonManaged">
              <el-option label="服务器" value="0" />
              <el-option label="虚拟机" value="1" />
              <el-option label="容器" value="2" />
              <el-option label="交换机" value="3" />
              <el-option label="防火墙" value="4" />
              <el-option label="路由器" value="5" />
              <el-option label="动环系统" value="6" />
              <el-option label="录像机或摄像头" value="7" />
              <el-option label="传感器" value="8" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="资源类型" prop="dev_character">
            <el-select v-model="formData.dev_character" placeholder="请选择资源类型" style="width: 100%">
              <el-option label="GPU节点 - 台·日" value="GPU节点" />
              <el-option label="CPU节点 - 台·月" value="CPU节点" />
              <el-option label="存储 - T·月" value="存储" />
              <el-option label="容器云 - 卡·时" value="容器云" />
              <el-option label="其他 - 台·月" value="其他" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="提供商" prop="provider">
            <el-select
              v-model="formData.provider"
              placeholder="请选择提供商"
              style="width: 100%"
              @change="handleProviderChange"
              :loading="loading"
              :disabled="isNonManaged"
            >
              <el-option
                v-for="item in providerOptions"
                :key="item.provider_id"
                :label="item.provider"
                :value="item.provider"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="可用区" prop="az_name">
            <el-select
              v-model="formData.az_name"
              placeholder="请选择可用区"
              style="width: 100%"
              @change="handleAzChange"
              :disabled="!formData.provider || isNonManaged"
              :loading="azLoading"
            >
              <el-option
                v-for="item in azOptions"
                :key="item.az_id"
                :label="item.az_name"
                :value="item.az_name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="开始时间" prop="start_time">
            <el-date-picker
              v-model="formData.start_time"
              type="datetime"
              placeholder="选择开始时间"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="isNonManaged"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结束时间" prop="end_time">
            <el-date-picker
              v-model="formData.end_time"
              type="datetime"
              placeholder="选择结束时间"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="isNonManaged"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="算力规格：" prop="products_id">
        <el-select 
          v-model="formData.products_id" 
          placeholder="请选择算力规格" 
          style="width: 100%;" 
          :loading="productsLoading"
          :disabled="isNonManaged"
        >
          <el-option 
            v-for="item in productsOptions" 
            :key="item.id" 
            :label="item.title" 
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    
      <el-form-item label="状态：" prop="status">
        <el-select v-model="formData.status" placeholder="请选择状态" style="width: 100%;" :disabled="isNonManaged">
          <el-option label="有效" :value="0"></el-option>
          <el-option label="无效" :value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="使用状态：" prop="active_state" > 
        <el-select v-model="formData.active_state" placeholder="请选择状态" style="width: 100%;"  :disabled="true">
          <el-option label="空闲" :value="0"></el-option>
          <el-option label="占用" :value="1"></el-option>
          <el-option label="维护中" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="运行状态：" prop="running_state">
        <el-select v-model="formData.running_state" placeholder="请选择运行状态" style="width: 100%;" :disabled="isNonManaged">
          <el-option label="在线" :value="0"></el-option>
          <el-option label="离线" :value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="formData.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              :disabled="isNonManaged"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="设备规格型号" prop="ext_06">
            <el-select
              v-model="formData.ext_06"
              placeholder="请选择设备规格型号"
              style="width: 100%"
              :loading="resourceTypeLoading"
              :disabled="isNonManaged"
            >
              <el-option
                v-for="item in resourceTypeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="规格描述" prop="spec_desc">
            <el-input
              v-model="formData.spec_desc"
              type="textarea"
              :rows="3"
              placeholder="请输入规格描述"
              :disabled="isNonManaged"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditDeviceDialog',
  props: {
    isNonManaged: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // IP 校验
    const validateIP = (rule, value, callback) => {
      const ipPattern = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
      if (!value) return callback(new Error('请输入IP地址'));
      if (!ipPattern.test(value)) return callback(new Error('IP格式错误'));
      const parts = value.split('.').map(Number);
      if (parts.some(p => p < 0 || p > 255 || (p.toString().length > 1 && p.toString()[0] === '0'))) {
        return callback(new Error('IP段不能有前导零且范围在0-255'));
      }
      callback();
    };

    return {
      dialogVisible: false,
      devId: '',

      submitLoading: false,
      loading: false,
      azLoading: false,
      productsLoading: false,
      resourceTypeLoading: false,

      providerOptions: [],
      azOptions: [],
      productsOptions: [],
      resourceTypeOptions: [],

      formData: {
        host_ip: '',
        hostname: '',
        ipmi_addr: '',
        ipmi_user: '',
        dev_type: '',
        dev_character: '',
        start_time: '',
        end_time: '',
        status:null,
        active_state:null,
        running_state:null,
        remark: '',
        spec_desc: '',
        provider: '',       // 显示字段
        az_name: '',        // 显示字段
        provider_id: '',    // 实际提交ID
        az_id: '',          // 实际提交ID
        ext_05: 0,
        ext_06: '',
        products_id: ''
      },

      formRules: {
        host_ip: [
          { required: true, message: '请输入设备IP', trigger: 'blur' },
          { validator: validateIP, trigger: 'blur' }
        ],
        hostname: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        ipmi_addr: [
          { required: true, message: '请输入IPMI地址', trigger: 'blur' },
          { validator: validateIP, trigger: 'blur' }
        ],
        ipmi_user: [
          { required: true, message: '请输入IPMI用户', trigger: 'blur' }
        ],
        dev_character: [
          { required: true, message: '请选择资源类型', trigger: 'change' }
        ],
        start_time: [
          {
            validator: (rule, value, callback) => {
              callback(); // 非必填
            },
            trigger: 'change'
          }
        ],
        end_time: [
          {
            validator: (rule, value, callback) => {
              const startTime = this.formData.start_time;
              const endTime = value;

              if (!startTime || !endTime) {
                return callback();
              }

              const start = new Date(startTime);
              const end = new Date(endTime);

              if (end <= start) {
                callback(new Error('结束时间必须大于开始时间'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      }
    };
  },

  methods: {
    /**
     * 打开编辑弹窗
     */
    async openDialog(row) {
      if (!row || !row.dev_id) {
        this.$message.error('无效数据');
        return;
      }

      this.devId = row.dev_id;
      this.resetForm();

      try {
        await Promise.all([
          this.fetchProviders(),
          this.fetchProducts(),
          this.fetchResourceTypes()
        ]);

        // 填充基础数据
        Object.assign(this.formData, {
          host_ip: row.host_ip == null ? '' : row.host_ip,
          hostname: row.hostname == null ? '' : row.hostname,
          ipmi_addr: row.ipmi_addr == null ? '' : row.ipmi_addr,
          ipmi_user: row.ipmi_user == null ? '' : row.ipmi_user,
          dev_type: row.dev_type == null ? '' : row.dev_type,
          dev_character: row.dev_character == null ? '' : row.dev_character,
          start_time: row.start_time == null ? '' : row.start_time,
          end_time: row.end_time == null ? '' : row.end_time,
          status: row.status == null ? '' : row.status,
          active_state: row.active_state == null ? '' : row.active_state,
          running_state: row.running_state == null ? '' : row.running_state,
          remark: row.remark == null ? '' : row.remark,
          spec_desc: row.spec_desc == null ? '' : row.spec_desc,
          provider_id: row.provider_id == null ? '' : row.provider_id,
          az_id: row.az_id == null ? '' : row.az_id,
          ext_05: row.ext_05 == null ? 0 : row.ext_05,
          ext_06: row.ext_06 == null ? '' : row.ext_06,
          products_id: row.products_id == null ? '' : row.products_id,
          provider: '',
          az_name: ''
        });

        // 设置 provider 名称
        if (this.formData.provider_id) {
          const providerObj = this.providerOptions.find(p => p.provider_id === this.formData.provider_id);
          if (providerObj) {
            this.formData.provider = providerObj.provider;
            await this.fetchAzByProvider(this.formData.provider);

            // 设置 az_name
            if (this.formData.az_id) {
              const azObj = this.azOptions.find(az => az.az_id === this.formData.az_id);
              if (azObj) {
                this.formData.az_name = azObj.az_name;
              } else {
                this.$message.warning('原可用区已不存在');
                this.formData.az_id = '';
                this.formData.az_name = '';
              }
            }
          }
        }
      } catch (err) {
        this.$message.error('加载数据失败');
      }

      this.dialogVisible = true;

      this.$nextTick(() => {
        this.$refs.editForm.clearValidate();
      });
    },

    fetchProducts() {
      this.productsLoading = true;
      return this.$axios.get('/api-30216/api/compute-products', {
        params: {
          page: 1,
          pageSize: 100
        }
      })
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.productsOptions = res.data.map(item => ({
              id: item.id,
              title: item.title
            }));
          } else {
            this.$message.warning('获取算力规格失败');
            this.productsOptions = [];
          }
        })
        .catch(() => {
          this.$message.error('网络错误，无法获取算力规格');
          this.productsOptions = [];
        })
        .finally(() => {
          this.productsLoading = false;
        });
    },

    /**
     * 获取资源类型列表
     */
    fetchResourceTypes() {
      this.resourceTypeLoading = true;
      return this.$axios.get('/api-30216/api/compute-types')
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.resourceTypeOptions = res.data.map(item => ({
              id: item.id,
              name: item.name
            }));
          } else {
            this.$message.warning('获取资源类型失败');
            this.resourceTypeOptions = [];
          }
        })
        .catch(() => {
          this.$message.error('网络错误，无法获取资源类型');
          this.resourceTypeOptions = [];
        })
        .finally(() => {
          this.resourceTypeLoading = false;
        });
    },

    /**
     * 获取提供商列表
     */
    fetchProviders() {
      this.loading = true;
      return this.$axios.get('/api-30216/api/regions')
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.providerOptions = res.data.map(item => ({
              provider_id: item.id,
              provider: item.provider
            }));
          } else {
            this.$message.warning('获取提供商失败');
            this.providerOptions = [];
          }
        })
        .catch(() => {
          this.$message.error('网络错误，无法获取提供商');
          this.providerOptions = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * 获取可用区（按 provider 名称）
     */
    fetchAzByProvider(providerName) {
      this.azLoading = true;
      this.azOptions = [];

      if (!providerName) return Promise.resolve();

      return this.$axios.get('/api-30216/api/zones', {
        params: { provider: providerName }
      })
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.azOptions = res.data.map(item => ({
              az_id: item.id,
              az_name: item.name
            }));
          } else {
            this.$message.warning('无可用区数据');
          }
        })
        .catch(() => {
          this.$message.error('获取可用区失败');
        })
        .finally(() => {
          this.azLoading = false;
        });
    },

    handleProviderChange(providerName) {
      const selected = this.providerOptions.find(p => p.provider === providerName);
      this.formData.provider_id = selected ? selected.provider_id : '';
      this.formData.az_name = '';
      this.formData.az_id = '';
      this.fetchAzByProvider(providerName);
    },

    handleAzChange(azName) {
      const selected = this.azOptions.find(az => az.az_name === azName);
      this.formData.az_id = selected ? selected.az_id : '';
    },

    handleClose() {
      this.$refs.editForm.resetFields();
      this.devId = '';
      this.providerOptions = [];
      this.azOptions = [];
    },

    resetForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
      this.formData.provider_id = '';
      this.formData.az_id = '';
      this.formData.products_id = '';
      this.azOptions = [];
      this.productsOptions = [];
      this.resourceTypeOptions = [];
    },

    /**
     * 提交表单（PUT 请求）
     */
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;

        if (!this.formData.provider_id) {
          this.$message.error('提供商ID缺失');
          return;
        }
        if (!this.formData.az_id) {
          this.$message.error('可用区ID缺失');
          return;
        }

        const payload = { ...this.formData };
        this.submitLoading = true;

        this.$axios.put(`/api-30216/api/devices/${this.devId}`, payload)
          .then(res => {
            const data = res.data || res;
            if (data.code === 200) {
              this.$message.success(data.message || '更新成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新
            } else {
              this.$message.error(data.message || '更新失败');
            }
          })
          .catch(err => {
            const msg = err.response && err.response.data && err.response.data.message || err.message ||  '请求失败';
            this.$message.error(msg);
            console.error('提交错误:', err);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 15px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.dialog-footer {
  text-align: right;
}
</style>